import {
  takeEvery,
  takeLatest,
  call,
  put,
  select,
  cancelled,
} from "redux-saga/effects";
import { setStates, setSuppliers, fetchError, setChartsData } from "../actions";
import {
  FETCH_STATES,
  FETCH_SUPPLIERS,
  SET_SELECTED_STATE,
  FETCH_CHARTSDATA,
} from "../types";
import {
  fetchStatesApi,
  fetchLoadZonesApi,
  fetchRateClassesApi,
  fetchPriceTrendChartData,
  fetchPriceTrendMinMaxChartData,
  fetchForwardCurveChartData,
  fetchForwadCurveMinMaxChartData,
} from "../../api";
import { RateClassifications } from "../../const/index";
import {
  STATIC_CUSTOM_PRICING_TRENDS,
  STATIC_CUSTOM_PRICING_TRENDS_MIN_MAX,
} from "../../../customPricing/const/nonPremiumStaticData";

function* fetchAndDispatchChart(apiFn, chartType, params) {
  const controller = new AbortController();
  try {
    const response = yield call(apiFn, {
      ...params,
      signal: controller.signal,
    });
    yield put(setChartsData(response, chartType));
  } catch (error) {
    if (error?.name === "AbortError") {
      // silently ignore aborted requests
    } else {
      console.error(`Error fetching ${chartType}:`, error);
    }
  } finally {
    if (yield cancelled()) {
      controller.abort();
    }
  }
}

function* fetchChartsData(action: any) {
  try {
    const {
      clientId,
      selectedClientIdentifier,
      userToken,
      IsNotAnonymized,
      isSystemAdmin,
      isPremium,
    } = action.payload || {};
    const selectedMarket = yield select(
      (state) => state.pricing.selectedMarket
    );
    // Prefer last applied commodity from Redux; fallback to selectedMarket commodity
    const appliedCommodity = yield select((state) => state.pricing.commodity);
    const commodity = (() => {
      if (appliedCommodity === 1 || appliedCommodity === 2) {
        return appliedCommodity;
      }
      const marketCommodity = selectedMarket?.commodity;
      if (
        marketCommodity === "Electricity" ||
        marketCommodity === "Electric" ||
        marketCommodity === "electric" ||
        marketCommodity === 1 ||
        marketCommodity === "1"
      ) {
        return 1;
      }
      if (
        marketCommodity === "NatGas" ||
        marketCommodity === "Gas" ||
        marketCommodity === "Nat Gas" ||
        marketCommodity === 2 ||
        marketCommodity === "2"
      ) {
        return 2;
      }
      return "";
    })();
    // debugger;
    let MarketEnerexIdentifier = yield select(
      (state) => state.pricing.selectedMarket.value
    );
    MarketEnerexIdentifier = commodity === 2 ? null : MarketEnerexIdentifier;
    const fromDate = yield select((state) => state.pricing.fromDate);
    const toDate = yield select((state) => state.pricing.toDate);
    const effectiveFromDate = yield select(
      (state) => state.pricing.effectiveFromDate
    );
    const effectiveToDate = yield select(
      (state) => state.pricing.effectiveToDate
    );
    const startFromDate = yield select((state) => state.pricing.startFromDate);
    const startToDate = yield select((state) => state.pricing.startToDate);
    const selectedStateName = yield select(
      (s) => s.pricing.selectedState?.name
    );
    const statesList = yield select((state) => state.pricing.states);
    const isAllSelected = selectedStateName === "All" || !selectedStateName;
    const selectedStatesArray = isAllSelected
      ? []
      : // ? (statesList || [])
        //     .filter((s: any) => s && s.name && s.name !== 'All')
        //     .map((s: any) => s.name)
        [selectedStateName];
    const terms = yield select((state) => state.pricing.terms);
    const selectedTerm = terms.find((state: any) => state?.isSelected)?.value;
    const ProductType = yield select((state) => state.pricing.productTypes);
    // const selectedProductType = ProductType.find((state: any) => state?.isSelected)?.value;
    const selectedProductType =
      ProductType?.filter((state: any) => state?.isSelected)?.map(
        (state: any) => state.value
      ) || [];
    const costComponent = yield select((state) => state.pricing.costComponents);
    // const selectedProductType = ProductType.find((state: any) => state?.isSelected)?.value;
    const rawSelectedPassThrough =
      costComponent
        ?.filter((state: any) => state?.isSelected)
        ?.map((state: any) => state.value) || [];
    const hasAllSelected = rawSelectedPassThrough.includes("All");
    const hasAllPassthroughsSelected =
      rawSelectedPassThrough.includes("All Passthroughs");
    const normalizeCostComponentValue = (value: any) =>
      String(value || "")
        .trim()
        .toLowerCase()
        .replace(/[\s-]+/g, "");
    const allPassthroughValues =
      costComponent
        ?.map((state: any) => state.value)
        ?.filter((value: any) => {
          const normalizedValue = normalizeCostComponentValue(value);
          return (
            value &&
            normalizedValue !== "all" &&
            normalizedValue !== "allinclusive" &&
            normalizedValue !== "allpassthroughs"
          );
        }) || [];
    const passThroughValues = hasAllSelected
      ? []
      : hasAllPassthroughsSelected
      ? allPassthroughValues
      : rawSelectedPassThrough;
    //dependant dropdowns values
    const selectedUtility = yield select(
      (s) => s.pricing.selectedUtility?.value
    );
    const selectedRateClass = yield select(
      (s) => s.pricing.selectedRateClass?.name
    );
    const selectedLoadProfile = yield select(
      (s) => s.pricing.selectedLoadProfile?.value
    );
    const selectedLoadZone = yield select(
      (s) => s.pricing.selectedLoadZone?.name
    );
    const selectedBillingMethod = yield select(
      (s) => s.pricing.selectedBillingMethod?.name
    );
    const noOfMonths = yield select((state) => state.pricing.noOfMonths);
    const usage = yield select((s) => s.pricing.usage);
    const demand = yield select((s) => s.pricing.demand);
    const loadFactor = yield select((s) => s.pricing.loadFactor);
    const customerClass = yield select((s) => s.pricing.customerClass);
    const taxIncluded = yield select((s) => s.pricing.taxIncluded);
    const por = yield select((s) => s.pricing.por);

    if (!userToken) {
      console.warn("Missing user token for pricing chart request");
      return;
    }

    if (isPremium === false) {
      yield put(
        setChartsData(STATIC_CUSTOM_PRICING_TRENDS, "priceTrend", false)
      );
      yield put(
        setChartsData(
          STATIC_CUSTOM_PRICING_TRENDS_MIN_MAX,
          "priceTrendMinMax",
          false
        )
      );
      yield put(
        setChartsData(STATIC_CUSTOM_PRICING_TRENDS, "forwardCurve", false)
      );
      yield put(
        setChartsData(
          STATIC_CUSTOM_PRICING_TRENDS_MIN_MAX,
          "forwardCurveMinMax",
          false
        )
      );
      return;
    }

    const params = {
      userToken,
      commodity,
      selectedStates: selectedStatesArray,
      selectedTerm,
      fromDate,
      toDate,
      effectiveFromDate,
      effectiveToDate,
      startFromDate,
      startToDate,
      selectedUtility,
      selectedRateClass,
      selectedLoadProfile,
      selectedLoadZone,
      selectedBillingMethod,
      usage,
      demand,
      loadFactor,
      clientId,
      selectedClientIdentifier,
      selectedProductType,
      passThrough: passThroughValues,
      noOfMonths,
      MarketEnerexIdentifier,
      customerClass,
      taxIncluded,
      por,
      IsNotAnonymized,
      isSystemAdmin,
    };
    yield call(
      fetchAndDispatchChart,
      fetchPriceTrendChartData,
      "priceTrend",
      params
    );
    yield call(
      fetchAndDispatchChart,
      fetchPriceTrendMinMaxChartData,
      "priceTrendMinMax",
      params
    );
    yield call(
      fetchAndDispatchChart,
      fetchForwardCurveChartData,
      "forwardCurve",
      params
    );
    yield call(
      fetchAndDispatchChart,
      fetchForwadCurveMinMaxChartData,
      "forwardCurveMinMax",
      params
    );
  } catch (error) {
    yield put(fetchError("Failed to fetch chart data"));
  }
}

// function* fetchUtilitiesSaga(action: any) {
//   try {
//     const { state, commodity } = action.payload;

//     const token = yield select((state) => state.pricing.ECToken?.token);
//     const params = {
//       state,
//       commodity,
//       token
//     }
//     // Pass commodity through to your API client:
//     const list  = yield call(
//       fetchUtilitiesApi,
//       params
//     );
//     yield put(setUtilities(list));
//   } catch (err) {
//     yield put(fetchError('Failed to fetch utilities'));
//   }
// }

export function* watchPricingActions() {
  //   yield takeEvery(FETCH_STATES, fetchStatesSaga);
  //   yield takeEvery(FETCH_STATES, fetchStatesSaga);
  //   yield takeEvery(SET_SELECTED_STATE, fetchLoadZonesSaga);
  // Cancel any in-flight chart fetch when a new one starts
  yield takeLatest(FETCH_CHARTSDATA, fetchChartsData);
  // yield takeEvery(FETCH_UTILITIES, fetchUtilitiesSaga);
  //   yield takeEvery(FETCH_SUPPLIERS, fetchSuppliersSaga);
  //   yield takeEvery(FETCH_RATE_CLASSES, fetchRateClassesSaga);
}

// TODO: either remove or use these saga as per future requirements

// function* fetchSuppliersSaga(action: any) {
//   try {
//     const response = yield call(fetchSuppliersApi, action.payload);
//     yield put(setSuppliers(response));
//   } catch (error) {
//     yield put(fetchError('Failed to fetch suppliers'));
//   }
// }

// function* fetchRateClassesSaga(action: any) {
//   try {
//     const response = yield call(fetchRateClassesApi, action.payload);
//     yield put(setRateClasses(response));
//   } catch (error) {
//     yield put(fetchError('Failed to fetch rate classes'));
//   }
// }

// function* fetchStatesSaga() {
//   try {
//     const response = yield call(fetchStatesApi);
//     yield put(setStates(response));
//   } catch (error) {
//     yield put(fetchError('Failed to fetch states'));
//   }
// }

// function* fetchRateClassesSaga() {
//     try {
//       const rateClasesList = RateClassifications.map((rateClass) => { return {...rateClass, isSelected: false}});
//       yield put(setRateClasses(rateClasesList));
//     } catch (error) {
//       yield put(fetchError('Failed to fetch states'));
//     }
//   }

// function* fetchUtilitiesSaga(action: any) {
//   try {
//     const response = yield call(fetchUtilitiesApi, action.payload);
//     yield put(setUtilities(response));
//   } catch (error) {
//     yield put(fetchError('Failed to fetch utilities'));
//   }
// }

// function* fetchLoadZonesSaga(action: any) {
//   try {
//     const response = yield call(fetchLoadZonesApi, action.payload);
//     yield put(setLoadZones(response));
//   } catch (error) {
//     yield put(fetchError('Failed to fetch load zones'));
//   }
// }
